module.exports = __webpack_public_path__ + "img/video.4d1f27ec.png";